import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Page_Archive.module.css";
import { useSelector } from "react-redux";

const DEFAULT_TYPES = ["Bilateral", "Reverse Auction", "RFQ"];
const ALL_STATUSES = ["Closed", "Withdrawn", "Expired"];

const ArchiveHeader = ({
  onBack,
  initialType = "Bilateral",
  initialStatus = "Closed",
  onTypeChange,
  onStatusChange,
  types = DEFAULT_TYPES,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  )?.toLowerCase();

  const [type, setType] = useState(params.get("type") || initialType);
  const [status, setStatus] = useState(params.get("status") || initialStatus);

  const STATUSES =
    type === "Reverse Auction" && role === "generator"
      ? ["Closed"]
      : ALL_STATUSES;

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    search.set("type", type);
    search.set("status", status);
    navigate(
      { pathname: location.pathname, search: `?${search.toString()}` },
      { replace: true }
    );

    if (typeof onTypeChange === "function") onTypeChange(type);
    if (typeof onStatusChange === "function") onStatusChange(status);
  }, [
    type,
    status,
    location.search,
    location.pathname,
    navigate,
    onTypeChange,
    onStatusChange,
  ]);

  const handleBack = () => {
    if (typeof onBack === "function") return onBack();
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <button
          aria-label="Back"
          onClick={handleBack}
          className={styles.backButton}
        >
          ← Back
        </button>

        <div className={styles.tabs}>
          {types.map((t) => (
            <button
              key={t}
              onClick={() => setType(t)}
              aria-pressed={t === type}
              className={`${styles.tab} ${t === type ? styles.tabActive : ""}`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.tabs}>
        {STATUSES.map((s) => (
          <button
            key={s}
            onClick={() => setStatus(s)}
            aria-pressed={s === status}
            className={`${styles.tab} ${s === status ? styles.tabActive : ""}`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ArchiveHeader;
